(function () {
  'use strict';

  function init(root) {
    if (root.dataset.byogbInitialized) return;
    root.dataset.byogbInitialized = 'true';
    var config = JSON.parse(root.querySelector('script[data-byogb-config]').textContent);
    var catalog = new Map();
    var products = [];
    var selectedVariants = new Map();
    var items = {};
    var card = 'note'; // 'note' (free notecard), 'premium' (Giftie card) or 'none'
    var boxQty = 1; // how many identical boxes (Martha 2026-10-26: "just change the quantity")
    var cardPerGift = false;
    var qtyMax = Math.max(1, Number(config.qtyMax) || 50);
    var addedSignature = '';
    var addedItems = null; // what this box last put in the cart, so a re-add only sends the difference
    var addedTotals = null; // same, as total units per variant line (box line included), for any box quantity
    // The saved box and its cart memory are read at load, not at restore: a click while the catalog is
    // still loading must not cost the memory (bug 2026-10-30: the next add put the whole box in again).
    var savedAtLoad = null;
    try { savedAtLoad = JSON.parse(localStorage.getItem('byogb:v1') || 'null'); }
    catch (error) { /* Storage may be unavailable. */ }
    if (location.hash.indexOf('box=') < 0 && savedAtLoad && typeof savedAtLoad === 'object') {
      addedSignature = typeof savedAtLoad.addedSignature === 'string' ? savedAtLoad.addedSignature : '';
      addedItems = savedAtLoad.addedItems && typeof savedAtLoad.addedItems === 'object' && !Array.isArray(savedAtLoad.addedItems) ?
        savedAtLoad.addedItems : null;
      addedTotals = savedAtLoad.addedTotals && typeof savedAtLoad.addedTotals === 'object' && !Array.isArray(savedAtLoad.addedTotals) ?
        savedAtLoad.addedTotals : null;
    }
    var addingToCart = false;
    var quickViewProduct = null;
    var quickViewVariantId = '';
    var quickViewImages = [];
    var quickViewCache = new Map();
    var category = 'all';
    var colors = new Set();
    var query = '';
    var searchTimer;
    var toastTimer;
    var loaded = false;
    var userTouched = false;
    var cardInCart = false;
    var cardPollTimer;
    var activeDialog = null;
    var dialogOpener = null;
    var occasionName = '';
    var vibeIndex = 0;
    var grid = root.querySelector('[data-byogb-grid]');
    var search = root.querySelector('[data-byogb-search]');
    var sort = root.querySelector('[data-byogb-sort]');
    var tray = root.querySelector('[data-byogb-tray]');
    var mobar = root.querySelector('[data-byogb-mobar]');
    var message = root.querySelector('[data-byogb-message]');
    var messageMax = Math.max(0, Number(config.messageMax) || 250);
    var excluded = new Set((config.excludedTypes || []).map(normalize));

    function syncMobileBarHeight() {
      if (mobar) document.documentElement.style.setProperty('--byogb-mobar-h', (mobar.getBoundingClientRect().height || 64) + 'px');
    }
    syncMobileBarHeight();
    window.addEventListener('resize', syncMobileBarHeight);
    if (mobar && window.ResizeObserver) new ResizeObserver(syncMobileBarHeight).observe(mobar);

    // The theme header shrinks once stuck but --header-height keeps its full size, which left a gap above
    // the sticky filters and tray. Follow the header's real bottom edge.
    var siteHeader = document.querySelector('.site-header');
    var stickyTimer = null;
    function syncStickyTop() {
      if (!siteHeader) return;
      var box = siteHeader.getBoundingClientRect();
      // off screen for a moment before the theme pins it: use its height, never 0
      root.style.setProperty('--byogb-sticky-top', Math.round(box.bottom > 0 ? box.bottom : box.height) + 'px');
    }
    function syncStickyTopSoon() {
      syncStickyTop();
      clearTimeout(stickyTimer);
      stickyTimer = setTimeout(syncStickyTop, 400); // after the header's own transition
    }
    syncStickyTop();
    window.addEventListener('scroll', syncStickyTopSoon, {passive: true});
    window.addEventListener('resize', syncStickyTopSoon);
    if (siteHeader) new MutationObserver(syncStickyTopSoon).observe(siteHeader, {attributes: true, attributeFilter: ['class']});

    function syncMessageCount() {
      if (!message) return;
      message.maxLength = messageMax;
      if (message.value.length > messageMax) message.value = message.value.slice(0, messageMax);
      put('[data-byogb-message-count]', message.value.length + ' / ' + messageMax);
      var limit = root.querySelector('[data-byogb-message-limit]');
      if (limit) limit.hidden = card !== 'note' || !messageMax || message.value.length < messageMax ||
        !root.querySelector('[data-byogb-card-option="premium"]');
    }
    if (message) message.addEventListener('input', syncMessageCount);
    syncMessageCount();

    function normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    function escape(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
        return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character];
      });
    }

    function str(id, vars) {
      return String((config.strings || {})[id] || '').replace(/\{(count|name|occasion|reason|total)\}/g, function (match, key) {
        return vars && vars[key] != null ? String(vars[key]) : match;
      });
    }

    function fmt(cents) {
      var amount = Number(cents || 0) / 100;
      var format = String(config.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
      return format.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator)\s*\}\}/g, function (match, key) {
        var parts = amount.toFixed(key === 'amount_no_decimals' ? 0 : 2).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, key === 'amount_with_comma_separator' ? '.' : ',');
        if (parts[1] === '00') parts.pop();
        return parts.join(key === 'amount_with_comma_separator' ? ',' : '.');
      }).trim();
    }

    function each(selector, callback) {
      root.querySelectorAll(selector).forEach(callback);
    }

    function put(selector, value) {
      each(selector, function (element) { element.textContent = value; });
    }

    function count() {
      return Object.keys(items).reduce(function (sum, id) { return sum + items[id]; }, 0);
    }

    function itemsSubtotal() {
      return Object.keys(items).reduce(function (sum, id) {
        var entry = catalog.get(id);
        return sum + (entry ? Number(entry.variant.price) * items[id] : 0);
      }, 0);
    }

    function total() {
      return (Number(config.box.price || 0) + itemsSubtotal()) * boxQty +
        (card === 'premium' && cardInCart && config.premiumCard ? Number(config.premiumCard.price || 0) : 0);
    }

    function selected(product) {
      return product.variants.find(function (variant) {
        return String(variant.id) === selectedVariants.get(String(product.id));
      }) || product.variants[0];
    }

    function variantImage(product, variant) {
      return variant.image || product.image || '';
    }

    function signature() {
      return Object.keys(items).sort(function (a, b) { return Number(a) - Number(b); }).map(function (id) {
        return id + ':' + items[id];
      }).join(',') + ';c=' + card + (boxQty > 1 ? ';q=' + boxQty : '') +
        (card === 'note' && cardPerGift && boxQty > 1 ? ';g=1' : '');
    }

    function setBoxQty(value) {
      var next = Math.round(Number(value));
      boxQty = Number.isFinite(next) ? Math.min(qtyMax, Math.max(1, next)) : 1;
    }

    // Total units per cart line for this box at the current quantity (box line included).
    function targetTotals() {
      var totals = {};
      totals[String(config.box.variantId)] = boxQty;
      Object.keys(items).forEach(function (id) { totals[id] = items[id] * boxQty; });
      return totals;
    }

    function alreadyInCart() {
      return !!count() && !!addedSignature && signature() === addedSignature;
    }

    function saveBox() {
      try { localStorage.setItem('byogb:v1', JSON.stringify({items: items, card: card, qty: boxQty, perGift: cardPerGift, addedSignature: addedSignature, addedItems: addedItems, addedTotals: addedTotals})); }
      catch (error) { /* Storage may be unavailable. */ }
    }

    function syncCartNotice() {
      var same = alreadyInCart();
      each('[data-byogb-in-cart-note]', function (note) { note.hidden = !same; });
      enableAddToCart();
    }

    function matchesCategory(product, index) {
      if (index === 'all') return true;
      var group = (config.categories || [])[Number(index)];
      return !!group && (group.types || []).some(function (type) { return normalize(type) === normalize(product.type); });
    }

    function matchesColor(product, index) {
      var color = (config.colors || [])[Number(index)];
      if (!color) return false;
      var tags = (product.colors || []).map(normalize);
      return (color.values || []).some(function (value) {
        var tag = normalize(value);
        return tags.includes('p:' + tag) || (config.matchSecondary && tags.includes('s:' + tag));
      });
    }

    function filtered() {
      var list = products.filter(function (product) {
        return matchesCategory(product, category) &&
          (!colors.size || Array.from(colors).some(function (index) { return matchesColor(product, index); })) &&
          (!query || normalize(product.title + ' ' + product.vendor).includes(query));
      });
      var mode = sort ? sort.value : 'featured';
      if (mode === 'price-asc' || mode === 'price-desc') {
        list.sort(function (a, b) {
          var diff = Number(selected(a).price) - Number(selected(b).price);
          return mode === 'price-asc' ? diff : -diff;
        });
      } else if (mode === 'az') {
        list.sort(function (a, b) { return String(a.title).localeCompare(String(b.title)); });
      }
      return list;
    }

    function cardHtml(product) {
      var variant = selected(product);
      var id = String(variant.id);
      var qty = items[id] || 0;
      var choices = product.variants.length > 1 ?
        '<select data-byogb-variant-select aria-label="Choose an option for ' + escape(product.title) + '">' +
        product.variants.map(function (option) {
          return '<option value="' + escape(option.id) + '"' + (String(option.id) === id ? ' selected' : '') + '>' +
            escape(option.title) + '</option>';
        }).join('') + '</select>' : '';
      return '<div class="byogb-card' + (qty ? ' is-in' : '') + '" data-byogb-card data-product-id="' +
        escape(product.id) + '" data-variant-id="' + escape(id) + '" data-price="' + escape(variant.price) + '">' +
        '<div class="byogb-card-media">' +
        '<span class="byogb-card-badge"' + (qty ? '' : ' hidden') + '>' + escape(str('in_box')) + '</span>' +
        (variantImage(product, variant) ? '<img src="' + escape(variantImage(product, variant)) + '" alt="' + escape(variant.image ? variant.title : product.alt || product.title) + '" loading="lazy">' : '') +
        '<button type="button" data-byogb-qv-open>' + escape(str('qv_open_label')) + '</button>' +
        '</div><div class="byogb-card-body"><div class="byogb-card-vendor">' + escape(product.vendor) + '</div>' +
        '<div class="byogb-card-title">' + escape(product.title) + '</div>' + choices +
        '<div class="byogb-card-foot"><span data-byogb-card-price>' + escape(fmt(variant.price)) + '</span>' +
        '<button type="button" data-byogb-add' + (qty ? ' hidden' : '') + '>' + escape(str('add_label')) + '</button>' +
        '<span class="byogb-card-stepper"' + (qty ? '' : ' hidden') + '><button type="button" data-byogb-dec aria-label="Remove one ' +
        escape(product.title) + '">−</button><span data-byogb-qty>' + qty + '</span><button type="button" data-byogb-inc aria-label="Add one ' +
        escape(product.title) + '">+</button></span></div></div></div>';
    }

    function renderChips() {
      var chips = root.querySelector('[data-byogb-chips]');
      if (!chips) return;
      var active = [];
      if (category !== 'all') {
        var group = (config.categories || [])[Number(category)];
        if (group) active.push({kind: 'category', value: category, label: group.label});
      }
      colors.forEach(function (index) {
        var color = (config.colors || [])[Number(index)];
        if (color) active.push({kind: 'color', value: index, label: color.label});
      });
      if (query) active.push({kind: 'search', value: '', label: search.value.trim()});
      chips.innerHTML = active.map(function (chip) {
        return '<button type="button" data-byogb-chip="' + chip.kind + '" data-value="' + escape(chip.value) +
          '" aria-label="' + escape(str('clear_all')) + ': ' + escape(chip.label) + '">× ' + escape(chip.label) + '</button>';
      }).join('');
      each('[data-byogb-clear-all]', function (button) {
        if (!button.closest('[data-byogb-empty]')) button.hidden = !active.length;
      });
    }

    function renderGrid(preserveScroll) {
      var scrollY = window.scrollY;
      var list = filtered();
      grid.innerHTML = list.map(cardHtml).join('');
      put('[data-byogb-count]', str(list.length === 1 ? 'count_one' : 'count_many', {count: list.length}));
      var empty = root.querySelector('[data-byogb-empty]');
      if (empty) empty.hidden = !loaded || !!list.length;
      each('[data-byogb-category]', function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.byogbCategory === category));
      });
      each('[data-byogb-color]', function (button) {
        button.setAttribute('aria-pressed', String(colors.has(button.dataset.byogbColor)));
      });
      var clear = root.querySelector('[data-byogb-search-clear]');
      if (clear) clear.hidden = !search.value;
      renderChips();
      if (preserveScroll && window.scrollY !== scrollY) window.scrollTo(0, scrollY);
    }

    function syncCard(element) {
      var qty = items[element.dataset.variantId] || 0;
      element.classList.toggle('is-in', qty > 0);
      var badge = element.querySelector('.byogb-card-badge');
      if (badge) badge.hidden = !qty;
      var add = element.querySelector('[data-byogb-add]');
      if (add) add.hidden = !!qty;
      var stepper = element.querySelector('.byogb-card-stepper');
      if (stepper) stepper.hidden = !qty;
      var number = element.querySelector('[data-byogb-qty]');
      if (number) number.textContent = qty;
    }

    function renderExtras() {
      each('[data-byogb-extra]', function (element) {
        var id = element.dataset.variantId;
        var entry = catalog.get(id);
        element.hidden = !entry;
        element.style.display = entry ? '' : 'none';
        if (!entry) return;
        var qty = items[id] || 0;
        element.classList.toggle('is-in', qty > 0);
        var badge = element.querySelector('[data-byogb-extra-added]');
        badge.hidden = !qty;
        badge.setAttribute('aria-label', qty ? str('extras_in_box', {count: qty}) : '');
        badge.querySelector('[data-byogb-extra-added-count]').textContent = qty > 1 ? String(qty) : '';
      });
      each('.byogb-extras', function (strip) {
        strip.hidden = !strip.querySelector('[data-byogb-extra]:not([hidden])');
      });
    }

    function renderOccasions() {
      each('[data-byogb-occasion], [data-byogb-bifm-occasion]', function (button) {
        var occasion = (config.occasions || []).find(function (entry) { return entry.name === button.dataset.name; });
        button.hidden = !occasion || !(occasion.variants || []).some(function (id) { return catalog.has(String(id)); });
        button.style.display = button.hidden ? 'none' : '';
      });
    }

    function renderAvailableFilters() {
      each('[data-byogb-category]', function (button) {
        if (button.dataset.byogbCategory === 'all') return;
        button.hidden = !products.some(function (product) {
          return matchesCategory(product, button.dataset.byogbCategory);
        });
        button.style.display = button.hidden ? 'none' : '';
      });
      each('[data-byogb-color]', function (button) {
        button.hidden = !products.some(function (product) {
          return matchesColor(product, button.dataset.byogbColor);
        });
        button.style.display = button.hidden ? 'none' : '';
      });
    }

    function trayRow(id) {
      var entry = catalog.get(id);
      if (!entry) return '';
      var product = entry.product;
      var variant = entry.variant;
      var qty = items[id];
      var title = product.title + (normalize(variant.title) === 'default title' ? '' : ' · ' + variant.title);
      return '<div class="byogb-tray-row" data-byogb-tray-row data-variant-id="' + escape(id) + '">' +
        (variantImage(product, variant) ? '<img src="' + escape(variantImage(product, variant)) + '" alt="' + escape(variant.image ? variant.title : product.alt || product.title) + '" loading="lazy">' : '') +
        '<div class="byogb-tray-item"><strong>' + escape(title) + '</strong></div>' +
        '<span class="byogb-tray-price">' + escape(fmt(Number(variant.price) * qty)) + '</span>' +
        '<div class="byogb-tray-stepper"><button type="button" data-byogb-tray-dec aria-label="Remove one ' + escape(product.title) +
        '">−</button><span>' + qty + '</span><button type="button" data-byogb-tray-inc aria-label="Add one ' +
        escape(product.title) + '">+</button></div></div>';
    }

    function renderTray() {
      var quantity = count();
      var subtotal = itemsSubtotal();
      var price = fmt(total());
      var body = root.querySelector('[data-byogb-tray-body]');
      if (body) body.innerHTML = quantity ? Object.keys(items).map(trayRow).join('') : '<p>' + escape(str('tray_empty')) + '</p>';
      put('[data-byogb-item-count], [data-byogb-mobar-count]', str(quantity === 1 ? 'items_one' : 'items_many', {count: quantity}));
      put('[data-byogb-box-price]', fmt(config.box.price));
      put('[data-byogb-items-subtotal]', fmt(subtotal));
      put('[data-byogb-total], [data-byogb-mobar-total]', price);
      var itemLine = root.querySelector('[data-byogb-items-subtotal]');
      if (itemLine && itemLine.previousElementSibling) itemLine.previousElementSibling.textContent = str('line_items', {count: quantity});
      each('[data-byogb-card-line]', function (line) {
        line.hidden = card !== 'premium' || !cardInCart || !config.premiumCard;
        line.style.display = line.hidden ? 'none' : '';
        var amount = line.querySelector('span:last-child');
        if (amount && config.premiumCard) amount.textContent = fmt(config.premiumCard.price);
      });
      var fillAt = Math.max(1, Number(config.fullAt) || 5);
      each('[data-byogb-fill-bar]', function (bar) { bar.style.width = Math.min(100, quantity / fillAt * 100) + '%'; });
      var fillId = quantity === 0 ? 'fill_empty' : quantity < 3 ? 'fill_start' :
        quantity < fillAt ? 'fill_generous_soon' : quantity <= 8 ? 'fill_full' : 'fill_generous';
      put('[data-byogb-fill-text]', str(fillId));
      each('.byogb-fullness', function (wrapper) { wrapper.classList.toggle('is-full', quantity >= fillAt); });
      each('[data-byogb-review-open]', function (button) { button.disabled = !quantity; });
      put('[data-byogb-hint]', str(quantity ? 'hint_ready' : 'hint_empty'));
      syncCartNotice();
      renderExtras();
    }

    function liveAnnounce() {
      put('[data-byogb-live]', 'Your box now has ' + str(count() === 1 ? 'items_one' : 'items_many', {count: count()}) + ', total ' + fmt(total()) + '.');
    }

    function enableAddToCart() {
      var button = root.querySelector('[data-byogb-add-to-cart]');
      var cardNeeded = card === 'premium' && !cardInCart;
      var notice = root.querySelector('[data-byogb-card-needed]');
      if (notice) notice.hidden = !cardNeeded;
      if (button) button.disabled = addingToCart || alreadyInCart() || cardNeeded;
    }

    function toast(message) {
      var element = root.querySelector('[data-byogb-toast]');
      if (!element) return;
      element.textContent = message;
      element.classList.add('is-shown', 'is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { element.classList.remove('is-shown', 'is-visible'); }, 1900);
    }

    function update(id, delta, announce) {
      if (!catalog.has(String(id))) return;
      userTouched = true;
      var next = (items[id] || 0) + delta;
      if (next > 0) items[id] = next;
      else delete items[id];
      each('[data-byogb-card]', syncCard);
      renderTray();
      saveBox();
      liveAnnounce();
      if (announce && delta > 0) toast(str('toast_added', {name: catalog.get(String(id)).product.title}));
    }

    function setItems(values) {
      userTouched = true;
      items = {};
      Object.keys(values || {}).forEach(function (id) {
        var qty = Number(values[id]);
        if (catalog.has(String(id)) && Number.isSafeInteger(qty) && qty > 0) items[id] = qty;
      });
      each('[data-byogb-card]', syncCard);
      renderTray();
      saveBox();
      liveAnnounce();
    }

    function clearFilters() {
      category = 'all';
      colors.clear();
      query = '';
      if (search) search.value = '';
      clearTimeout(searchTimer);
      renderGrid(false);
    }

    function openTray() {
      tray.classList.add('is-open');
      tray.setAttribute('role', 'dialog');
      tray.setAttribute('aria-modal', 'true');
      document.body.classList.add('byogb-locked');
    }

    function closeTray() {
      tray.classList.remove('is-open');
      tray.removeAttribute('role');
      tray.removeAttribute('aria-modal');
      if (!activeDialog) document.body.classList.remove('byogb-locked');
    }

    function dialogFocus(event) {
      if (!activeDialog) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.from(activeDialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return !element.hidden && !element.closest('[hidden]') && element.getClientRects().length;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openDialog(dialog, closeSelector) {
      if (!dialog) return;
      dialogOpener = document.activeElement;
      activeDialog = dialog;
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      document.body.classList.add('byogb-locked');
      document.addEventListener('keydown', dialogFocus);
      var close = dialog.querySelector('button' + closeSelector);
      if (close) close.focus();
    }

    function closeDialog() {
      if (!activeDialog) return;
      clearInterval(cardPollTimer);
      activeDialog.classList.remove('is-open');
      activeDialog.setAttribute('aria-hidden', 'true');
      activeDialog = null;
      document.removeEventListener('keydown', dialogFocus);
      if (!tray.classList.contains('is-open')) document.body.classList.remove('byogb-locked');
      if (dialogOpener && dialogOpener.isConnected) dialogOpener.focus();
      dialogOpener = null;
    }

    async function readPremiumCard() {
      if (card !== 'premium' || !config.premiumCard) return;
      try {
        var response = await fetch('/cart.js');
        if (!response.ok) return;
        var cartData = await response.json();
        cardInCart = Array.isArray(cartData.items) && cartData.items.some(function (item) {
          return String(item.product_id) === String(config.premiumCard.productId);
        });
        renderTray();
        put('[data-byogb-review-total]', fmt(total()));
        enableAddToCart();
      } catch (error) {
        // Keep the last cart result when a poll cannot complete.
      }
    }

    function syncCardPolling() {
      clearInterval(cardPollTimer);
      if (card !== 'premium' || !config.premiumCard) return;
      readPremiumCard();
      if (activeDialog === root.querySelector('[data-byogb-review]')) {
        cardPollTimer = setInterval(readPremiumCard, 2000);
      }
    }

    function syncReviewCard() {
      syncMessageCount();
      each('[data-byogb-card-option]', function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.byogbCardOption === card));
      });
      var message = root.querySelector('[data-byogb-message]');
      if (message) {
        message.hidden = card !== 'note';
        message.style.display = message.hidden ? 'none' : '';
        var label = root.querySelector('label[for="' + message.id + '"]');
        if (label) {
          label.hidden = card !== 'note';
          label.style.display = label.hidden ? 'none' : '';
        }
      }
      var counter = root.querySelector('[data-byogb-message-count]');
      if (counter) counter.hidden = card !== 'note';
      put('[data-byogb-qty-value]', String(boxQty));
      each('[data-byogb-qty-dec]', function (b) { b.disabled = boxQty <= 1; });
      each('[data-byogb-qty-inc]', function (b) { b.disabled = boxQty >= qtyMax; });
      var perGift = root.querySelector('[data-byogb-per-gift]');
      if (perGift) {
        perGift.hidden = card !== 'note' || boxQty < 2;
        var perGiftInput = perGift.querySelector('input');
        if (perGiftInput) perGiftInput.checked = cardPerGift;
      }
      var noneHelper = root.querySelector('[data-byogb-none-helper]');
      if (noneHelper) noneHelper.hidden = card !== 'none';
      var helper = root.querySelector('[data-byogb-premium-helper]');
      if (helper) helper.hidden = card !== 'premium';
      var slot = root.querySelector('[data-byogb-slot="card"]');
      if (slot) slot.hidden = card !== 'premium';
      put('[data-byogb-review-total]', fmt(total()));
      renderTray();
      saveBox();
      syncCardPolling();
    }

    function renderReview() {
      var list = root.querySelector('[data-byogb-review-list]');
      if (list) {
        list.innerHTML = '<li>' + (config.box.image ? '<img src="' + escape(config.box.image) + '" alt="' + escape(config.box.title) + '">' : '') +
          '<span>1 ×</span><span><strong>' + escape(config.box.title) + '</strong><small>' +
          escape(config.box.sub) + '</small></span><strong>' + escape(fmt(config.box.price)) + '</strong></li>' +
          Object.keys(items).map(function (id) {
            var entry = catalog.get(id);
            if (!entry) return '';
            var title = entry.product.title + (normalize(entry.variant.title) === 'default title' ? '' : ' · ' + entry.variant.title);
            return '<li>' + (variantImage(entry.product, entry.variant) ? '<img src="' + escape(variantImage(entry.product, entry.variant)) + '" alt="' + escape(title) + '">' : '') +
              '<span>' + items[id] + ' ×</span><span>' + escape(title) + '</span><strong>' +
              escape(fmt(Number(entry.variant.price) * items[id])) + '</strong></li>';
          }).join('');
      }
      var suggestions = root.querySelector('[data-byogb-suggestions]');
      if (suggestions) {
        suggestions.innerHTML = (config.suggestions || []).filter(function (id) {
          var entry = catalog.get(String(id));
          return entry && !Object.keys(items).some(function (chosenId) {
            var chosen = catalog.get(chosenId);
            return chosen && String(chosen.product.id) === String(entry.product.id);
          });
        }).slice(0, 4).map(function (id) {
          var entry = catalog.get(String(id));
          var product = entry.product;
          return '<div data-byogb-suggestion data-variant-id="' + escape(id) + '">' +
            (product.image ? '<img src="' + escape(product.image) + '" alt="' + escape(product.alt || product.title) + '" loading="lazy">' : '') +
            '<strong>' + escape(product.title) + '</strong><span>' + escape(fmt(entry.variant.price)) + '</span>' +
            '<button type="button" data-byogb-suggestion-add>' + escape(str('add_label')) + '</button></div>';
        }).join('');
        suggestions.parentElement.hidden = !suggestions.children.length;
      }
      put('[data-byogb-review-total]', fmt(total()));
      syncCartNotice();
    }

    function sanitizeDescription(html, destination) {
      var parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
      parsed.querySelectorAll('script, style, iframe').forEach(function (element) { element.remove(); });
      parsed.querySelectorAll('*').forEach(function (element) {
        Array.from(element.attributes).forEach(function (attribute) {
          if (/^on/i.test(attribute.name) ||
              ((attribute.name === 'href' || attribute.name === 'src') && /^\s*javascript:/i.test(attribute.value))) {
            element.removeAttribute(attribute.name);
          }
        });
      });
      destination.replaceChildren.apply(destination, Array.from(parsed.body.childNodes).map(function (node) {
        return document.importNode(node, true);
      }));
    }

    function renderQuickViewImage(url) {
      var media = root.querySelector('[data-byogb-qv-image]');
      if (!media) return;
      media.innerHTML = url ? '<img class="byogb-qv-main" src="' + escape(url) + '" alt="' + escape(quickViewProduct.title) + '">' : '';
      if (quickViewImages.length > 1) {
        media.innerHTML += '<div class="byogb-qv-thumbs">' + quickViewImages.slice(0, 4).map(function (image, index) {
          return '<button type="button" data-byogb-qv-thumb="' + index + '" aria-label="View image ' + (index + 1) + '"><img src="' +
            escape(image) + '" alt=""></button>';
        }).join('') + '</div>';
      }
    }

    function syncQuickView() {
      if (!quickViewProduct) return;
      var variant = quickViewProduct.variants.find(function (entry) { return String(entry.id) === quickViewVariantId; });
      if (!variant) return;
      put('[data-byogb-qv-price]', fmt(variant.price));
      var button = root.querySelector('[data-byogb-qv-add]');
      if (button) button.textContent = items[quickViewVariantId] ? str('extras_in_box', {count: items[quickViewVariantId]}) : str('add_label');
      renderQuickViewImage(variantImage(quickViewProduct, variant));
    }

    function openQuickView(product) {
      quickViewProduct = product;
      quickViewVariantId = String(selected(product).id);
      quickViewImages = [variantImage(product, selected(product))].filter(Boolean);
      put('[data-byogb-qv-title]', product.title);
      put('[data-byogb-qv-vendor]', product.vendor);
      var description = root.querySelector('[data-byogb-qv-desc]');
      if (description) description.replaceChildren();
      var variants = root.querySelector('[data-byogb-qv-variants]');
      if (variants) variants.innerHTML = product.variants.length > 1 ?
        '<select data-byogb-qv-select aria-label="Choose an option for ' + escape(product.title) + '">' +
        product.variants.map(function (variant) {
          return '<option value="' + escape(variant.id) + '"' + (String(variant.id) === quickViewVariantId ? ' selected' : '') + '>' +
            escape(variant.title) + '</option>';
        }).join('') + '</select>' : '';
      syncQuickView();
      openDialog(root.querySelector('[data-byogb-qv]'), '[data-byogb-qv-close]');
      if (!quickViewCache.has(product.handle)) {
        var route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        quickViewCache.set(product.handle, fetch(route + 'products/' + encodeURIComponent(product.handle) + '.js').then(function (response) {
          if (!response.ok) throw new Error('Product request failed');
          return response.json();
        }).catch(function () { return null; }));
      }
      quickViewCache.get(product.handle).then(function (details) {
        if (!details || quickViewProduct !== product) return;
        var images = (details.images || []).map(function (image) { return typeof image === 'string' ? image : image.src; }).filter(Boolean);
        quickViewImages = Array.from(new Set([variantImage(product, selected(product))].concat(images)));
        syncQuickView();
        if (description) sanitizeDescription(details.description, description);
      });
    }

    function openReview() {
      if (!count()) return;
      var review = root.querySelector('[data-byogb-review]');
      var view = root.querySelector('[data-byogb-review-view]');
      var confirm = root.querySelector('[data-byogb-confirm]');
      if (view) view.hidden = false;
      if (confirm) confirm.hidden = true;
      renderReview();
      openDialog(review, '[data-byogb-review-close]');
      syncReviewCard();
    }

    function visibleOccasions() {
      return (config.occasions || []).filter(function (occasion) {
        return (occasion.variants || []).some(function (id) { return catalog.has(String(id)); });
      });
    }

    function syncAssembler() {
      each('[data-byogb-bifm-occasion]', function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.name === occasionName));
      });
      each('[data-byogb-bifm-vibe]', function (button) {
        button.setAttribute('aria-pressed', String(Number(button.dataset.index) === vibeIndex));
      });
      var range = root.querySelector('[data-byogb-bifm-budget]');
      if (range) {
        var value = Number(range.value);
        put('[data-byogb-bifm-budget-out]', fmt(value * 100));
        range.style.setProperty('--byogb-budget-progress', ((value - Number(range.min)) / (Number(range.max) - Number(range.min)) * 100) + '%');
        var minus = root.querySelector('[data-byogb-bifm-minus]');
        var plus = root.querySelector('[data-byogb-bifm-plus]');
        if (minus) minus.disabled = value <= Number(range.min);
        if (plus) plus.disabled = value >= Number(range.max);
      }
    }

    function openAssembler() {
      userTouched = true;
      var first = visibleOccasions()[0];
      if (!visibleOccasions().some(function (occasion) { return occasion.name === occasionName; })) {
        occasionName = first ? first.name : '';
      }
      syncAssembler();
      var message = root.querySelector('[data-byogb-bifm-message]');
      if (message) message.hidden = true;
      openDialog(root.querySelector('[data-byogb-bifm]'), '[data-byogb-bifm-close]');
    }

    function assembleBox() {
      var range = root.querySelector('[data-byogb-bifm-budget]');
      var budget = Number(range ? range.value : config.budget.default) * 100;
      var occasion = visibleOccasions().find(function (entry) { return entry.name === occasionName; });
      var vibe = (config.vibes || [])[vibeIndex];
      var types = vibe && Array.isArray(vibe.types) ? vibe.types.map(normalize) : [];
      var chosen = {};
      var chosenProducts = new Set();
      var spent = 0;
      var size = 0;
      var target = Math.max(3, Math.min(8, Math.round(budget / 3000)));
      var candidates = [];
      var candidateProducts = new Set();
      function candidate(entry, starter) {
        if (!entry || candidateProducts.has(String(entry.product.id))) return;
        candidateProducts.add(String(entry.product.id));
        candidates.push({entry: entry, starter: starter});
      }
      if (occasion) (occasion.variants || []).forEach(function (id) { candidate(catalog.get(String(id)), true); });
      products.forEach(function (product) {
        if (!types.length || types.includes(normalize(product.type))) candidate(catalog.get(String(product.variants[0].id)), false);
      });
      function fits(option) {
        return !chosenProducts.has(String(option.entry.product.id)) && Number(option.entry.variant.price) <= budget - spent;
      }
      function add(option) {
        var entry = option.entry;
        if (!fits(option) || size >= 8) return;
        chosen[entry.variant.id] = 1;
        chosenProducts.add(String(entry.product.id));
        spent += Number(entry.variant.price);
        size += 1;
      }
      while (size < 8 && spent < 0.9 * budget) {
        var available = candidates.filter(fits);
        if (!available.length) break;
        var starter = available.find(function (option) { return option.starter; });
        var ideal = (budget - spent) / Math.max(1, target - size);
        var closest = available.sort(function (a, b) {
          return Math.abs(Number(a.entry.variant.price) - ideal) - Math.abs(Number(b.entry.variant.price) - ideal);
        }).slice(0, 3);
        add(starter || closest[Math.floor(Math.random() * closest.length)]);
      }
      while (size < 8 && spent < 0.9 * budget) {
        var largest = candidates.filter(fits).sort(function (a, b) {
          return Number(b.entry.variant.price) - Number(a.entry.variant.price);
        })[0];
        if (!largest) break;
        add(largest);
      }
      if (size < 3) {
        products.map(function (product) { return catalog.get(String(product.variants[0].id)); }).filter(Boolean)
          .forEach(function (entry) { candidate(entry, false); });
        candidates.filter(fits).sort(function (a, b) {
          return Number(a.entry.variant.price) - Number(b.entry.variant.price);
        }).forEach(function (option) { if (size < 3) add(option); });
      }
      if (size < 3) {
        var message = root.querySelector('[data-byogb-bifm-message]');
        if (message) { message.textContent = str('bifm_no_fit'); message.hidden = false; }
        return;
      }
      setItems(chosen);
      card = 'note';
      syncReviewCard();
      closeDialog();
      toast(str('bifm_toast', {occasion: occasionName}));
      if (window.innerWidth <= 1080) openTray();
      else tray.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }

    function parseSignature(value) {
      var parsed = {};
      String(value || '').split(';')[0].split(',').forEach(function (pair) {
        var match = /^(\d+):(\d+)$/.exec(pair);
        if (match) parsed[match[1]] = Number(match[2]);
      });
      return parsed;
    }

    // The live cart for a box this browser already added, or null for a box that was never added.
    // The cart is the truth, not the memory: lines removed or changed there are read back, and a cart that
    // cannot be read stops the add (throws) instead of adding the whole box on top of what is there.
    async function cartBase() {
      var added = addedTotals;
      if (!added) {
        // saves from before box quantities: per-box items, one box
        var perBox = addedItems || (addedSignature ? parseSignature(addedSignature) : null);
        if (!perBox) return null;
        added = Object.assign({}, perBox);
        added[String(config.box.variantId)] = 1;
      }
      var response = await fetch('/cart.js');
      if (!response.ok) throw new Error('');
      var data = await response.json();
      var cart = {};
      (data.items || []).forEach(function (line) {
        var id = String(line.variant_id);
        cart[id] = (cart[id] || 0) + line.quantity;
      });
      return {added: added, cart: cart};
    }

    async function addToCart(button) {
      if (button.disabled || !count() || (card === 'premium' && !cardInCart)) return;
      addingToCart = true;
      button.disabled = true;
      button.textContent = str('adding');
      var errorElement = root.querySelector('[data-byogb-error]');
      var added = false;
      var challenge = false;
      if (errorElement) { errorElement.textContent = ''; errorElement.hidden = true; }
      try {
        var target = targetTotals();
        var fullLines = Object.keys(target).map(function (id) { return {id: Number(id), quantity: target[id]}; });
        // Re-adding a box that is already in the cart sends only the difference (bug 2026-10-23: going
        // back from the cart, adding one item and pressing Add box to cart doubled every earlier item).
        var base = await cartBase();
        var lines = fullLines;
        var reductions = [];
        if (base) {
          lines = Object.keys(target).map(function (id) {
            return {id: Number(id), quantity: target[id] - (base.cart[id] || 0)};
          }).filter(function (line) { return line.quantity > 0; });
          Object.keys(target).forEach(function (id) {
            if ((base.cart[id] || 0) > target[id]) reductions.push({id: id, quantity: target[id]});
          });
          Object.keys(base.added).forEach(function (id) {
            if (!target[id] && base.cart[id]) reductions.push({id: id, quantity: Math.max(0, base.cart[id] - base.added[id])});
          });
        }
        var route = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';
        var response = lines.length ? await fetch(route, {
          method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: lines})
        }) : {ok: true};
        for (var r = 0; response.ok && r < reductions.length; r += 1) {
          var changeRoute = (window.theme && window.theme.routes && window.theme.routes.cartChange) || '/cart/change.js';
          if (!/\.js(?:\?|$)/.test(changeRoute)) changeRoute += '.js';
          response = await fetch(changeRoute, {
            method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(reductions[r])
          });
        }
        if (!response.ok) {
          var detail = {};
          if (response.status === 429 && !/json/i.test(response.headers.get('content-type') || '')) {
            challenge = true;
          } else {
            try { detail = await response.json(); }
            catch (error) { challenge = response.status === 429; }
          }
          if (challenge) throw new Error('');
          throw new Error(detail.description || detail.message || '');
        }
        var message = root.querySelector('[data-byogb-message]');
        var messageError = root.querySelector('[data-byogb-message-error]');
        if (messageError) messageError.hidden = true;
        var updateRoute = (window.theme && window.theme.routes && window.theme.routes.cartUpdate) || '/cart/update.js';
        if (!/\.js(?:\?|$)/.test(updateRoute)) updateRoute += '.js';
        var messageFailed = false;
        try {
          var updateResponse = await fetch(updateRoute, {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: {
              yuzuGiftMessage: card === 'note' && message ? message.value.slice(0, messageMax).trim() : '',
              // read by the Yuzu print flow: print the notecard this many times (one per box)
              yuzuCardCopies: card === 'note' && cardPerGift && boxQty > 1 ? String(boxQty) : ''
            }})
          });
          if (!updateResponse.ok) throw new Error('Gift message update failed');
        } catch (error) {
          messageFailed = true;
          if (messageError) {
            messageError.textContent = str('message_error');
            messageError.hidden = false;
          }
        }
        addedSignature = signature();
        addedItems = Object.assign({}, items);
        addedTotals = targetTotals();
        saveBox();
        syncCartNotice();
        document.dispatchEvent(new CustomEvent('cart:build', {bubbles: true}));
        added = true;
        if (!messageFailed) {
          window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
          return;
        }
        var view = root.querySelector('[data-byogb-review-view]');
        var confirm = root.querySelector('[data-byogb-confirm]');
        if (view) view.hidden = true;
        if (confirm) confirm.hidden = false;
        var another = root.querySelector('[data-byogb-build-another]');
        if (another) another.focus();
      } catch (error) {
        if (errorElement) {
          if (challenge) {
            var rootPrefix = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            var permalink = rootPrefix + 'cart/' + fullLines.map(function (line) {
              return line.id + ':' + line.quantity;
            }).join(',') + '?storefront=true';
            var giftMessage = root.querySelector('[data-byogb-message]');
            if (card === 'note' && giftMessage && giftMessage.value.slice(0, messageMax).trim()) {
              permalink += '&attributes%5ByuzuGiftMessage%5D=' + encodeURIComponent(giftMessage.value.slice(0, messageMax).trim());
            }
            var link = document.createElement('a');
            link.dataset.byogbCartFallback = '';
            link.className = 'byogb-button byogb-button-navy';
            link.href = permalink;
            link.textContent = str('challenge_link');
            errorElement.textContent = str('challenge_fallback');
            errorElement.appendChild(link);
          } else {
            errorElement.textContent = str('add_error', {reason: error.message});
          }
          errorElement.hidden = false;
        }
      } finally {
        addingToCart = false;
        enableAddToCart();
        button.textContent = str('add_to_cart');
      }
    }

    function share() {
      if (!count()) { toast(str('share_empty')); return; }
      var pairs = Object.keys(items).map(function (id) { return id + '.' + items[id]; });
      var hash = 'box=' + encodeURIComponent('1:' + pairs.join(',') + ';c=' + card + (boxQty > 1 ? ';q=' + boxQty : ''));
      history.replaceState(null, '', '#' + hash);
      var link = location.origin + location.pathname + location.search + '#' + hash;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        Promise.resolve().then(function () { return navigator.clipboard.writeText(link); }).then(function () {
          toast(str('share_copied'));
        }, function () { toast(str('share_saved')); });
      } else toast(str('share_saved'));
    }

    function restore() {
      var marker = location.hash.indexOf('box=');
      if (marker >= 0 && userTouched) return;
      if (marker < 0) {
        var saved = savedAtLoad;
        if (!saved || !saved.items || typeof saved.items !== 'object' || Array.isArray(saved.items)) return;
        var available = {};
        var skippedSaved = false;
        Object.keys(saved.items).forEach(function (id) {
          var qty = Number(saved.items[id]);
          if (!catalog.has(id) || !Number.isSafeInteger(qty) || qty < 1) { skippedSaved = true; return; }
          available[id] = qty;
        });
        // items picked while the catalog loaded go on top of the saved box
        if (userTouched) Object.keys(items).forEach(function (id) { available[id] = Math.max(available[id] || 0, items[id]); });
        setBoxQty(saved.qty);
        cardPerGift = saved.perGift === true;
        setItems(available);
        card = saved.card === 'premium' && config.premiumCard ? 'premium' : saved.card === 'none' ? 'none' : 'note';
        syncReviewCard();
        if (Object.keys(available).length) toast(str(skippedSaved ? 'restore_partial' : 'restore_ok'));
        return;
      }
      var raw;
      try { raw = decodeURIComponent(location.hash.slice(marker + 4).split('&')[0]); }
      catch (error) { return; }
      if (!raw.startsWith('1:')) return;
      var qtyMatch = /;q=(\d+)/.exec(raw);
      raw = raw.replace(/;q=\d+/, '');
      var parts = raw.slice(2).split(';c=');
      var restored = {};
      var skipped = false;
      if (parts[0]) parts[0].split(',').forEach(function (pair) {
        var match = /^(\d+)\.(\d+)$/.exec(pair);
        if (!match || !catalog.has(match[1]) || !Number.isSafeInteger(Number(match[2])) || Number(match[2]) < 1) {
          skipped = true;
          return;
        }
        restored[match[1]] = Number(match[2]);
      });
      setItems(restored);
      card = parts[1] === 'premium' && config.premiumCard ? 'premium' : parts[1] === 'none' ? 'none' : 'note';
      setBoxQty(qtyMatch ? Number(qtyMatch[1]) : 1);
      try {
        var own = JSON.parse(localStorage.getItem('byogb:v1') || 'null');
        if (own && own.addedSignature === signature()) {
          addedSignature = own.addedSignature;
          addedItems = own.addedItems && typeof own.addedItems === 'object' ? own.addedItems : null;
          addedTotals = own.addedTotals && typeof own.addedTotals === 'object' ? own.addedTotals : null;
        }
      } catch (error) { /* Storage may be unavailable. */ }
      syncReviewCard();
      toast(str(skipped ? 'restore_partial' : 'restore_ok'));
    }

    var api = {
      state: function () { return {items: Object.assign({}, items), card: card}; },
      itemsSubtotal: itemsSubtotal,
      total: total,
      openReview: openReview,
      openAssembler: openAssembler,
      share: share,
      restore: restore,
      setItems: setItems,
      render: function () { renderGrid(false); renderTray(); renderOccasions(); },
      toast: toast,
      fmt: fmt,
      str: str,
      catalog: catalog,
      config: config
    };
    window.byogb = api;

    root.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      var itemCard = button.closest('[data-byogb-card]');
      var trayRowElement = button.closest('[data-byogb-tray-row]');
      if (itemCard && button.matches('[data-byogb-add], [data-byogb-inc], [data-byogb-dec]')) {
        update(itemCard.dataset.variantId, button.matches('[data-byogb-dec]') ? -1 : 1, button.matches('[data-byogb-add]'));
      } else if (trayRowElement && button.matches('[data-byogb-tray-inc], [data-byogb-tray-dec]')) {
        update(trayRowElement.dataset.variantId, button.matches('[data-byogb-tray-dec]') ? -1 : 1, false);
      } else if (button.matches('[data-byogb-extra-add]')) {
        update(button.closest('[data-byogb-extra]').dataset.variantId, 1, false);
        if (activeDialog === root.querySelector('[data-byogb-review]')) {
          renderReview();
          put('[data-byogb-review-total]', fmt(total()));
          enableAddToCart();
        }
      } else if (button.matches('[data-byogb-category]')) {
        category = button.dataset.byogbCategory;
        renderGrid(false);
      } else if (button.matches('[data-byogb-color]')) {
        var index = button.dataset.byogbColor;
        if (colors.has(index)) colors.delete(index);
        else colors.add(index);
        renderGrid(false);
      } else if (button.matches('[data-byogb-chip]')) {
        if (button.dataset.byogbChip === 'category') category = 'all';
        if (button.dataset.byogbChip === 'color') colors.delete(button.dataset.value);
        if (button.dataset.byogbChip === 'search') {
          query = '';
          if (search) search.value = '';
          clearTimeout(searchTimer);
        }
        renderGrid(false);
      } else if (button.matches('[data-byogb-clear-all]')) {
        clearFilters();
      } else if (button.matches('[data-byogb-search-clear]')) {
        query = '';
        search.value = '';
        clearTimeout(searchTimer);
        renderGrid(false);
        search.focus();
      } else if (button.matches('[data-byogb-occasion]')) {
        var occasion = (config.occasions || []).find(function (entry) { return entry.name === button.dataset.name; });
        if (!occasion) return;
        var values = {};
        (occasion.variants || []).forEach(function (id) { if (catalog.has(String(id))) values[id] = 1; });
        if (!Object.keys(values).length) return;
        setItems(values);
        toast(str('toast_occasion', {occasion: occasion.name}));
        if (window.innerWidth <= 1080) openTray();
        else tray.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      } else if (button.matches('[data-byogb-mobar-open]')) {
        openTray();
      } else if (button.matches('[data-byogb-tray-close]')) {
        closeTray();
      } else if (button.matches('[data-byogb-qv-open]')) {
        var quickProduct = products.find(function (product) { return String(product.id) === itemCard.dataset.productId; });
        if (quickProduct) openQuickView(quickProduct);
      } else if (button.matches('[data-byogb-qv-thumb]')) {
        var image = quickViewImages[Number(button.dataset.byogbQvThumb)];
        var mainImage = root.querySelector('.byogb-qv-main');
        if (image && mainImage) mainImage.src = image;
      } else if (button.matches('[data-byogb-qv-add]')) {
        if (quickViewVariantId) update(quickViewVariantId, 1, true);
        syncQuickView();
      } else if (button.matches('[data-byogb-review-open]')) {
        api.openReview();
      } else if (button.matches('[data-byogb-bifm-open]')) {
        api.openAssembler();
      } else if (button.matches('[data-byogb-share]')) {
        api.share();
      } else if (button.matches('[data-byogb-review-close], [data-byogb-keep-editing], [data-byogb-bifm-close], [data-byogb-bifm-cancel], [data-byogb-qv-close]')) {
        closeDialog();
      } else if (button.matches('[data-byogb-suggestion-add]')) {
        update(button.closest('[data-byogb-suggestion]').dataset.variantId, 1, false);
        renderReview();
      } else if (button.matches('[data-byogb-use-note]')) {
        var noteOption = root.querySelector('[data-byogb-card-option="note"]');
        if (noteOption) noteOption.click();
      } else if (button.matches('[data-byogb-message-limit-cta]')) {
        var premiumOption = root.querySelector('[data-byogb-card-option="premium"]');
        if (premiumOption) premiumOption.click();
      } else if (button.matches('[data-byogb-qty-dec], [data-byogb-qty-inc]')) {
        setBoxQty(boxQty + (button.matches('[data-byogb-qty-inc]') ? 1 : -1));
        syncReviewCard();
        enableAddToCart();
      } else if (button.matches('[data-byogb-card-option]')) {
        if (button.dataset.byogbCardOption === 'premium' && !config.premiumCard) return;
        card = button.dataset.byogbCardOption;
        if (card === 'premium') cardInCart = false;
        enableAddToCart();
        syncReviewCard();
        if (card === 'premium') {
          var giftieButton = root.querySelector('[data-byogb-slot="card"] button');
          if (giftieButton) giftieButton.click();
        }
      } else if (button.matches('[data-byogb-add-to-cart]')) {
        addToCart(button);
      } else if (button.matches('[data-byogb-build-another]')) {
        setItems({});
        card = 'note';
        var message = root.querySelector('[data-byogb-message]');
        if (message) message.value = '';
        syncMessageCount();
        syncReviewCard();
        addedSignature = '';
        addedItems = null;
        addedTotals = null;
        boxQty = 1;
        cardPerGift = false;
        try { localStorage.removeItem('byogb:v1'); }
        catch (error) { /* Storage may be unavailable. */ }
        if (location.hash.indexOf('box=') >= 0) history.replaceState(null, '', location.pathname + location.search);
        closeDialog();
        window.scrollTo(0, 0);
      } else if (button.matches('[data-byogb-bifm-occasion]')) {
        occasionName = button.dataset.name;
        syncAssembler();
      } else if (button.matches('[data-byogb-bifm-vibe]')) {
        vibeIndex = Number(button.dataset.index);
        syncAssembler();
      } else if (button.matches('[data-byogb-bifm-minus], [data-byogb-bifm-plus]')) {
        var budgetInput = root.querySelector('[data-byogb-bifm-budget]');
        if (budgetInput) {
          var direction = button.matches('[data-byogb-bifm-plus]') ? 1 : -1;
          budgetInput.value = Math.max(Number(budgetInput.min), Math.min(Number(budgetInput.max), Number(budgetInput.value) + direction * Number(budgetInput.step)));
          syncAssembler();
        }
      } else if (button.matches('[data-byogb-bifm-go]')) {
        assembleBox();
      }
    });

    root.addEventListener('click', function (event) {
      if (event.target.matches('[data-byogb-review-close], [data-byogb-bifm-close], [data-byogb-qv-close]')) closeDialog();
    });

    var budgetRange = root.querySelector('[data-byogb-bifm-budget]');
    if (budgetRange) budgetRange.addEventListener('input', syncAssembler);

    grid.addEventListener('change', function (event) {
      if (!event.target.matches('[data-byogb-variant-select]')) return;
      var element = event.target.closest('[data-byogb-card]');
      var entry = catalog.get(event.target.value);
      if (!entry || String(entry.product.id) !== element.dataset.productId) return;
      selectedVariants.set(element.dataset.productId, event.target.value);
      element.dataset.variantId = event.target.value;
      element.dataset.price = entry.variant.price;
      element.querySelector('[data-byogb-card-price]').textContent = fmt(entry.variant.price);
      var image = element.querySelector('.byogb-card-media img');
      if (image) {
        image.src = variantImage(entry.product, entry.variant);
        image.alt = entry.variant.image ? entry.variant.title : entry.product.alt || entry.product.title;
      }
      syncCard(element);
    });
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-byogb-per-gift] input')) {
        cardPerGift = event.target.checked;
        saveBox();
        enableAddToCart();
        syncCartNotice();
        return;
      }
      if (!event.target.matches('[data-byogb-qv-select]') || !quickViewProduct) return;
      var entry = catalog.get(event.target.value);
      if (!entry || entry.product !== quickViewProduct) return;
      quickViewVariantId = String(entry.variant.id);
      selectedVariants.set(String(entry.product.id), quickViewVariantId);
      var visibleCard = grid.querySelector('[data-byogb-card][data-product-id="' + entry.product.id + '"]');
      if (visibleCard) {
        visibleCard.dataset.variantId = quickViewVariantId;
        visibleCard.dataset.price = entry.variant.price;
        var cardSelect = visibleCard.querySelector('[data-byogb-variant-select]');
        if (cardSelect) cardSelect.value = quickViewVariantId;
        visibleCard.querySelector('[data-byogb-card-price]').textContent = fmt(entry.variant.price);
        var image = visibleCard.querySelector('.byogb-card-media img');
        if (image) { image.src = variantImage(entry.product, entry.variant); image.alt = entry.variant.image ? entry.variant.title : entry.product.alt || entry.product.title; }
        syncCard(visibleCard);
      }
      syncQuickView();
    });
    if (search) search.addEventListener('input', function () {
      var clear = root.querySelector('[data-byogb-search-clear]');
      if (clear) clear.hidden = !search.value;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { query = normalize(search.value); renderGrid(false); }, 150);
    });
    if (sort) sort.addEventListener('change', function () { renderGrid(false); });

    renderTray();

    async function fetchFeedPage(page) {
      for (var attempt = 0; attempt < 4; attempt += 1) {
        var response = null;
        try { response = await fetch(config.feedUrl + '&page=' + page); }
        catch (error) {
          if (attempt === 3) throw error;
        }
        if (response) {
          if (!response.ok) {
            if (response.status !== 429 && response.status < 500) throw new Error('Catalog request failed');
            if (attempt === 3) throw new Error('Catalog request failed');
          } else {
            try { return await response.json(); }
            catch (error) {
              if (attempt === 3) throw error;
            }
          }
        }
        var retryAfter = response ? response.headers.get('Retry-After') : null;
        var delay = retryAfter && /^\d+(?:\.\d+)?$/.test(retryAfter.trim()) ?
          Math.min(Number(retryAfter), 5) * 1000 : [600, 1500, 3000][attempt];
        await new Promise(function (resolve) { setTimeout(resolve, delay); });
      }
    }

    // The saved or shared box is restored as soon as every one of its variants is in the catalog,
    // not after the last feed page; until then the tray hides its counts instead of showing "0 items".
    var pendingRestore = (function () {
      var ids = [];
      var marker = location.hash.indexOf('box=');
      if (marker >= 0) {
        try {
          decodeURIComponent(location.hash.slice(marker + 4).split('&')[0]).slice(2).split(';c=')[0].split(',')
            .forEach(function (pair) { var m = /^(\d+)\./.exec(pair); if (m) ids.push(m[1]); });
        } catch (error) { /* Malformed link: restore() reports it. */ }
      } else {
        try {
          var saved = JSON.parse(localStorage.getItem('byogb:v1') || 'null');
          if (saved && saved.items && typeof saved.items === 'object') ids = Object.keys(saved.items);
        } catch (error) { /* Storage may be unavailable. */ }
      }
      return ids;
    })();
    var restoreDone = false;
    if (pendingRestore.length) root.setAttribute('data-byogb-restoring', '');
    function finishRestore() {
      if (restoreDone) return;
      restoreDone = true;
      api.restore();
      root.removeAttribute('data-byogb-restoring');
    }

    async function loadCatalog() {
      try {
        if (!config.feedUrl) throw new Error('Missing catalog feed');
        for (var page = 1; ; page += 1) {
          var data = await fetchFeedPage(page);
          if (!data || !Array.isArray(data.products) || !Number.isInteger(data.page_size) || data.page_size < 1) {
            throw new Error('Invalid catalog response');
          }
          data.products.forEach(function (product) {
            if (!product || !Array.isArray(product.variants) || !product.variants.length || excluded.has(normalize(product.type)) ||
                String(product.id) === String(config.box.productId) ||
                (config.premiumCard && String(product.id) === String(config.premiumCard.productId))) return;
            product.variants = product.variants.filter(function (variant) { return variant && variant.available !== false; });
            if (!product.variants.length) return;
            products.push(product);
            product.variants.forEach(function (variant) { catalog.set(String(variant.id), {product: product, variant: variant}); });
          });
          loaded = true;
          renderGrid(page > 1);
          renderExtras();
          renderOccasions();
          if (pendingRestore.length && pendingRestore.every(function (id) { return catalog.has(id); })) finishRestore();
          if ((Number.isInteger(data.pages) && data.pages > 0 && page >= data.pages) || data.products.length < data.page_size) break;
        }
        renderAvailableFilters();
        finishRestore();
        var loading = root.querySelector('[data-byogb-loading]');
        if (loading) loading.hidden = true;
      } catch (error) {
        root.removeAttribute('data-byogb-restoring');
        var loadError = root.querySelector('[data-byogb-load-error]');
        var indicator = root.querySelector('[data-byogb-loading]');
        if (loadError) loadError.hidden = false;
        if (indicator) indicator.hidden = true;
      }
    }
    loadCatalog();
  }

  function start() {
    document.querySelectorAll('[data-byogb]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    document.querySelectorAll('[data-byogb]').forEach(function (root) {
      if (root.dataset.sectionId === sectionId) init(root);
    });
  });
}());
